// PROCEDURE TYPE
export const GET_PROCEDURE_TYPES = '/procedure_type/query';
export const GET_PROCEDURE_TYPE = '/procedure_type/';
export const POST_PROCEDURE_TYPE = '/procedure_type/';
export const PUT_PROCEDURE_TYPE = '/procedure_type/';
export const DELETE_PROCEDURE_TYPE = '/procedure_type/';
export const CHECK_PROCEDURE_TYPE_EXISTS = '/procedure_type/query';
